import { createApi } from '@reduxjs/toolkit/query/react';

const { app } = PULSE;

import { accountHeaderWithRetryBQ } from './base-queries/account-header-with-retry';

// RTK Query update: Define an api service with a base URL and retry attempts
// RTK Query update: Endpoints can be added here or injected in components
export const contentApi = createApi({
    reducerPath: 'contentApi',
    baseQuery: accountHeaderWithRetryBQ(app.environment.aflApi),
    endpoints: (builder) => ({
        // GET /content/{accountName}/{type}/{lang}/{id} - Get Content by type/lang and ID
        getContentItem: builder.query({
            query: ({ type, id, params }) =>
                app.common.createContentPath(type, params, app.language, id)
        }),
        // GET /content/{accountName}/{type}/{lang} - Get Content by type/lang
        getContent: builder.query({
            query: ({ type, params }) => {
                return `/content/${app.account}/${type}/${
                    app.language
                }${app.common.prepareParams(params)}`;
            }
        }),
        // GET /broadcasting/{type}/ - Get Match Events
        getMatchEvents: builder.query({
            query: (params) => {
                return `/broadcasting/match-events${app.common.prepareParams(
                    params
                )}`;
            }
        })
    })
});

export const {
    useGetContentItemQuery,
    useGetContentQuery,
    useGetMatchEventsQuery
} = contentApi;
